import React from 'react';
import AssessmentCenterComponent from '../../components/proStudent/AssessmentCenter/AssessmentCenter';

const AssessmentCenter = () => {
  return (
    <div>
      <AssessmentCenterComponent />
    </div>
  );
};

export default AssessmentCenter;
